'use client';
import Image from "next/image";
import Link from "next/link";
import styles from "@/app/styles/offer.module.scss";
import useDeviceType from "@/app/utils/useDeviceType";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Carousel } from 'react-bootstrap';
import https from "https";
import { formatEventDate } from '@/app/utils/formatDate';
import CodeDisplay from "@/app/utils/content";
import CaroeuslOffer from "@/app/components/offer-carousel";

const OfferCarousel = ({ offersPostImages,postMainTitle }) => {

const settingsOffers = {
    dots: false,
    arrows: false,
    infinite: true, 
    autoplay:true,
    slidesToShow: 4,
    slidesToScroll: 1,
    focusOnSelect: true,
    pauseOnHover: false,
    responsive: [
        {
        breakpoint: 1025,
        settings: {
            slidesToShow: 2,
        },
        },
        {
        breakpoint: 991,
        settings: {
            slidesToShow: 2,
        },
        },
        {
        breakpoint: 600,
        settings: {
            slidesToShow: 2,
        },
        },
    ],
};

  return (
    <>
        <section className={`${styles.offersPosts} bg-dark-meroon green-mesh  section-padding-bottom section-padding-top`}>
            <div className={styles.postWraper}>
            <h6 className={styles.TitleOfferInerPost}>{postMainTitle}</h6>
            </div>   
            <div className={styles.sliderPostGAllery}>
            <Slider className={`inner-offers-slider ${styles.inner_offers_slider_offers}`} {...settingsOffers}>
                {offersPostImages.map((url, index) => (
                    <img key={index} src={url} alt={`Gallery Image ${index + 1}`} className={styles.galleryImage} />
                ))}
            </Slider>
            </div>
        </section>
    </>
  );
}
export default OfferCarousel;